import { FC } from "react";
import { CheckCircle } from "lucide-react";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import LeopartOnDarkvector from "../../assets/icons/LeopartOnDarkvector";
import "./ConfirmedGym.scss";

const ConfirmedGym: FC = () => {
  const { navigate } = useCustomNavigate();
  return (
    <div className="confirmed-page">
      <div className="confirmed-page__bg" />
      <div className="confirmed-card">
        <div className="confirmed-card__logo">
          <LeopartOnDarkvector w={"36px"} h={"36px"} />
          <span className="confirmed-card__logo-text">Leopart</span>
        </div>

        <div className="confirmed-card__icon-wrapper">
          <CheckCircle size={40} strokeWidth={1.5} />
        </div>

        <h1 className="confirmed-card__title">Account confermato</h1>
        <p className="confirmed-card__desc">
          La tua password è stata creata con successo.<br />
          Adesso puoi accedere con le tue credenziali.
        </p>

        <button
          className="confirmed-card__btn"
          onClick={() => navigate("GYM_LOGIN")}
        >
          Accedi
        </button>
      </div>
    </div>
  );
};

export default ConfirmedGym;
